import { DuckSelector, createSelector, createCachedSelector } from '@atc/modular-redux';
import { LruObjectCache } from 're-reselect';
const DEFAULT_EMPTY_DEAL = {};
export default duck => ({
  getState: new DuckSelector(selectors => createSelector(selectors.getDuckState, localState => localState)),
  getDealDetails: new DuckSelector(selectors => state => selectors.getDuckState(state).dealDetails),
  getHasDeals: new DuckSelector(selectors => createSelector(selectors.getDealDetails, dealDetails => dealDetails && Object.keys(dealDetails).length > 0)),
  getDealByListingVin: new DuckSelector(selectors => createCachedSelector(selectors.getDealDetails, (state, vin) => vin, function (dealDetails, vin) {
    if (dealDetails === void 0) {
      dealDetails = {};
    }
    const matchingDealId = Object.keys(dealDetails).filter(dealId => dealDetails[dealId].vehicle.vin === vin)[0];
    return dealDetails[matchingDealId];
  })({
    keySelector: (state, vin) => vin || 'default',
    cacheObject: new LruObjectCache({
      cacheSize: 100
    })
  })),
  getCreditAppDeals: new DuckSelector(selectors => state => selectors.getDuckState(state).creditAppDeals),
  getCreditAppDealsByOwnerId: new DuckSelector(selectors => createCachedSelector(selectors.getCreditAppDeals, (_, ownerId) => ownerId, (creditAppDeals, ownerId) => {
    if (ownerId) {
      return creditAppDeals?.find(deal => deal?.dealId?.length && ownerId === deal?.ownerId);
    }
    return DEFAULT_EMPTY_DEAL;
  })({
    keySelector: (state, ownerId) => ownerId || 'default',
    cacheObject: new LruObjectCache({
      cacheSize: 100
    })
  })),
  getTransformedDealDetails: new DuckSelector(selectors => createSelector(selectors.getDealDetails, selectors.getHasDeals, function (dealDetails, hasDeals) {
    if (dealDetails === void 0) {
      dealDetails = {};
    }
    if (!hasDeals && Object.keys(dealDetails).length === 0) {
      return {};
    }
    return Object.entries(dealDetails).reduce((acc, _ref) => {
      let [dealXgId, dealDetail = {}] = _ref;
      const {
        vehicle = {}
      } = dealDetail;
      const {
        condition = '',
        make,
        model,
        year,
        trim
      } = vehicle;
      if (dealDetails[dealXgId]) {
        const title = `${condition?.toLowerCase() === 'certifiedpreowned' ? 'Certified' : condition} ${year} ${make} ${model}${trim ? ' ' + trim : ''}`;
        acc[dealXgId] = {
          ...dealDetails[dealXgId],
          vehicle: {
            ...vehicle,
            title
          }
        };
      }
      return acc;
    }, {});
  })),
  getDealNotifications: new DuckSelector(selectors => createSelector(selectors.getDuckState, localState => localState.dealNotifications)),
  getHideReceipt: new DuckSelector(selectors => createSelector(selectors.getDuckState, localState => localState.hideReceipt)),
  getHideReceiptByListingId: new DuckSelector(selectors => createCachedSelector(selectors.getDuckState, (state, id) => id, function (localState, id) {
    if (localState === void 0) {
      localState = {};
    }
    if (id === void 0) {
      id = '';
    }
    return localState?.hideReceipt?.includes(id);
  })({
    keySelector: (state, id) => id || 'default',
    cacheObject: new LruObjectCache({
      cacheSize: 100
    })
  }))
});